import { useCallback } from 'react'
import type { Referral } from '@/types'
import logSearchFormAnalytics from '@/shared-utils/log-search-form-analytics'
import { handleSubmit } from '../SearchForm/utils'

interface CruiseFormData {
  location: string
  cruiseLine: string
  startDate: string
  duration: string
}

interface UseCruiseFormSubmitProps {
  formData: CruiseFormData
  referral: Referral
  cguid: string
  isMobile: boolean
}

export const useCruiseFormSubmit = ({
  formData,
  referral,
  cguid,
  isMobile
}: UseCruiseFormSubmitProps) => {
  const onSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault()
      const todaysDate = new Date()

      handleSubmit(
        {
          location: formData.location,
          cruiseLine: formData.cruiseLine,
          startDate: formData.startDate,
          duration: formData.duration
        },
        referral,
        todaysDate
      )

      logSearchFormAnalytics(cguid, 'homepage', 'cruises', isMobile)
    },
    [formData, referral, cguid, isMobile]
  )

  return { onSubmit }
}
